// Client settings. Bun inlines PUBLIC_* env vars at bundle time (see bunfig.toml
// and build.ts), so each one must be read by its full literal name.
const values = {
  PUBLIC_KINDE_DOMAIN: process.env.PUBLIC_KINDE_DOMAIN,
  PUBLIC_KINDE_CLIENT_ID: process.env.PUBLIC_KINDE_CLIENT_ID,
  PUBLIC_KINDE_AUDIENCE: process.env.PUBLIC_KINDE_AUDIENCE,
};

/** Names of required settings that are unset, so the app can say what to fix. */
export const missingConfig = Object.entries(values)
  .filter(([, value]) => !value)
  .map(([key]) => key);

export const kinde = {
  domain: values.PUBLIC_KINDE_DOMAIN ?? "",
  clientId: values.PUBLIC_KINDE_CLIENT_ID ?? "",
  // The API only accepts tokens issued for its audience (KINDE_AUDIENCE).
  audience: values.PUBLIC_KINDE_AUDIENCE ?? "",
  redirectUri: `${window.location.origin}/callback`,
  logoutUri: `${window.location.origin}/sign-in`,
};
